import { createSlice } from "@reduxjs/toolkit";

// 🧠 تابع کمکی برای گرفتن اطلاعات از localStorage
const getInitialState = () => {
  const userData = localStorage.getItem("userData");
  if (userData) {
    try {
      return JSON.parse(userData);
    } catch (e) {
      console.error("Failed to parse userData from localStorage:", e);
    }
  }
  return {
    token: "",
    user: {
      code: "",
      national_code: "",
      first_name: "",
      last_name: "",
      birthday: null,
      address: [],
      wallet_balance: null,
      mail: "",
      phone: "",
      utype: "NORMAL_CUSTOMER",
      is_active: false,
      favorite: null,
      default_address: null,
      created_at: null,
      updated_at: null,
    },
  };
};

// ⬇️ مقدار اولیه از localStorage یا حالت پیش‌فرض
const initialState = getInitialState();

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserData: (state, action) => {
      const newState = { ...state, ...action.payload };
      localStorage.setItem("userData", JSON.stringify(newState));
      return newState;
    },

    updateUserField: (state, action) => {
      const { key, value } = action.payload;
      state.user[key] = value;
      localStorage.setItem("userData", JSON.stringify(state));
    },

    addAddress: (state, action) => {
      state.user.address.push(action.payload);
      localStorage.setItem("userData", JSON.stringify(state));
    },

    removeAddress: (state, action) => {
      state.user.address = state.user.address.filter(
        (addr) => addr.code !== action.payload
      );
      localStorage.setItem("userData", JSON.stringify(state));
    },

    clearUser: () => {
      localStorage.removeItem("userData");
      return getInitialState();
    },
  },
});

export const {
  setUserData,
  updateUserField,
  addAddress,
  removeAddress,
  clearUser,
} = userSlice.actions;

export default userSlice.reducer;
